import Checkbox from '@components/ui/inputs/Checkbox'
import FormControl from '@components/ui/inputs/FormControl'
import { CustomerUpdateFormValues } from '@features/account/api/customer-update'
import { FC, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import s from './M61ProfileView.module.scss'

type UserProfileConsentNewsletterToggleProps = {}

export const UserProfileConsentNewsletterToggle: FC<
  UserProfileConsentNewsletterToggleProps
> = ({}) => {
  const form = useFormContext<CustomerUpdateFormValues>()
  const checked = form.watch('newsletterSignup')

  const [loading, setLoading] = useState(true)
  // api call, set loading...
  const getKlaviyoStatus = async () => {
    const response = await fetch('/api/account/get-newsletter-status')

    if (response.ok) {
      const data = await response.json()

      form.setValue('newsletterSignup', {
        value: data.newsletterStatus,
        changed: false,
      })
      setLoading(false)
    }
  }

  useEffect(() => {
    getKlaviyoStatus()
  }, [])

  if (loading)
    return (
      <div className={s.formInputWrapper}>
        <FormControl.Label>Newsletter</FormControl.Label>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <div
            className={s.skeleton}
            style={{ width: '24px', height: '24px' }}
          ></div>

          <div
            className={s.skeleton}
            style={{ width: '64px', height: '24px' }}
          ></div>
        </div>
      </div>
    )

  return (
    <FormControl className={s.formInputWrapper} layout="horizontal">
      <FormControl.Label>Newsletter</FormControl.Label>
      <Checkbox
        onChange={(e) => {
          form.setValue('newsletterSignup', {
            value: e.target.checked,
            changed: true,
          })
        }}
        value={checked.value}
        checked={checked.value}
      />
      <FormControl.Caption>
        {checked.value ? 'Subscribed' : 'Unsubscribed'}
      </FormControl.Caption>
    </FormControl>
  )
}
